import PropTypes from 'prop-types';
import { t } from 'Utils/localization/i18next';
import MissingDataNotificationBanner from './MissingDataNotificationBanner';

const DynamicNotification = ({
  allowEmail,
  allowSMS,
  allowDirectMail,
  allowPhone
}) => {
  const isAnyConsentSelected =
    allowEmail || allowSMS || allowDirectMail || allowPhone;

  if (isAnyConsentSelected) {
    return null;
  }

  return (
    <MissingDataNotificationBanner
      text={t('missingDataNotification.text')}
      action={t('missingDataNotification.button')}
    />
  );
};

DynamicNotification.propTypes = {
  allowEmail: PropTypes.bool,
  allowSMS: PropTypes.bool,
  allowDirectMail: PropTypes.bool,
  allowPhone: PropTypes.bool
};

export default DynamicNotification;
